export const roundToTwoDecimals = (num: number | string | null | undefined) => {
	if (num === null || num === undefined || num === "") return "N/A";
	const parsed = parseFloat(num.toString());
	return isNaN(parsed) ? "N/A" : parsed.toFixed(2);
};
